"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalStyle = void 0;

var _styles = require("react-components/styles");

var _styledComponents = require("styled-components");

var _typographyStyles = require("./typography/typography-styles");

/**
 * Module dependencies.
 */

/**
 * Export `GlobalStyle` component.
 */
var GlobalStyle = (0, _styledComponents.createGlobalStyle)(["", " body{", " color:", ";font-family:", ";}ol{list-style:none;margin:0;padding:0;}svg{display:block;}sub,sup{font-size:60%;}"], _styles.globalStyles, _typographyStyles.typography.styles.textNormal, (0, _styles.color)('secondary'), _typographyStyles.typography.fontFamilies.inter);
exports.GlobalStyle = GlobalStyle;